// extracted by mini-css-extract-plugin
module.exports = {"dialog":"clinical-portal-3__MediaAccessDialog__dialog"};